exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#table-dd td {\n  font-size: 11px;\n  padding: 1px 3px;\n}\n#table-dd table,\n#table-dd table th,\n#table-dd table td {\n  border: 0 !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ashutosh/submission/src/app/appcomponents/claim.component.css
// module id = ../../../../../src/app/appcomponents/claim.component.css
// module chunks = main